// @vendors
import { toast } from "react-toastify";

// @types
import { IParamsCompany } from "../types/professional.types";

// @services
import profileService from "../services/profile.service";
import { UserRole } from "../types/auth.types";
import { ProfessionalInfo, UserInfo } from "../types/profile.types";

//xervix data
export const xervixPhoneNumber = "+57 304 661 1901";
export const xervixAdmonEmail = "admon@xervix.com.co";
export const twiterLink = "https://x.com"
export const instagramLink = "https://www.instagram.com/"
export const discordLink = "https://discord.com"

export const handleSignOut = (openSpinner: Function) => {
    openSpinner(true);
    setTimeout(() => {
        localStorage.clear();
        window.location.reload();
        openSpinner(false);
    }, 1000);
};

export const documentTypes = {
    rut: "RUT",
    identityDocument: "IdentityDocumentLegalRepresentant",
    bankCertificate: "BankingCertificate",
    commerceDocument: "CertifiedOfChamberAndCommerce",
}

export const updateDataCompany = async (props: IParamsCompany) => {
    const { field, formValue, openSpinner, t, getProfessional, userType, userId } = props
    const value = { [field]: formValue[field] };
    const withoutValue = Object.values(value).some((x) => x === "");
    if (withoutValue) return toast.error(t("error.requiredDataField"));
    openSpinner(true);
    try {
        await profileService.updateProfile(value, userType, userId);
        getCompanyData(openSpinner, getProfessional, t);
        //openSpinner(false);
    } catch (error) {
        openSpinner(false);
        toast.error(t("error.postData"))
    }
}

const getCompanyData = async (openSpinner: any, getProfessional: any, t: any) => {
    openSpinner(true);
    try {
        await getProfessional();
        openSpinner(false);
    } catch (error) {
        openSpinner(false);
        toast.error(t("error.callList"));
    }
}

export const formatPrice = (price: number | string) => {
    if (!price) return '$0'
    const fotmatValue = price.toLocaleString('es-CO', { style: 'currency', currency: 'COP' });
    return fotmatValue;
}

export const getNameUser = (role: UserRole | null, data: ProfessionalInfo | null, userData: UserInfo | null) => {
    if (!role?.length) return;
    if (role?.includes(UserRole.PROFESSIONAL)) return `${data?.name} ${data?.lastNames ?? ''}`
    if (role?.includes(UserRole.USER)) return `${userData?.names} ${userData?.lastNames ?? ''}`
    return "";
}

export const optionsCancelService = [
    "Ya no necesito el servicio",
    "Conseguí un servicio más conveniente",
    "Considero que el costo es demasiado alto",
    "Tuve un imprevisto y ya no puedo recibir el servicio",
    "Elegí el servicio equivocado o ingresé datos incorrectos",
    "Tengo dudas sobre la calidad o seguridad del servicio",
    "Otro motivo"
]